<script>
import StakeholderService from "@/services/StakeholderService";
import Cloner from "@/libraries/Cloner";

export default {
    props: {
        category: {},
        context: {}
    },
    data() {
        return {
            editing: false,
            errors: false,
            entity: {
                id: null,
                name: null,
                title: null,
                address: null,
                phone: null,
                email: null,
                note: null,
                custom_string: null,
                custom_number: null
            },
            columns: {
                name_col_active: "name",
                title_col_active: "title",
                address_col_active: "address",
                phone_col_active: "phone",
                email_col_active: "email",
                note_col_active: "note",
                custom_string_col_active: "custom_string",
                custom_number_col_active: "custom_number"
            },
            customValues: {}
        };
    },
    computed: {
        customColumns() {
            return this.category.custom_columns || [];
        }
    },
    async created() {
        if (!this.context.empty) {
            this.editing = true;
            this.entity = Cloner.pickClone(
                this.context,
                Object.keys(this.entity)
            );
            // Load existing custom values
            if (this.context.custom_values) {
                this.context.custom_values.forEach(cv => {
                    this.$set(
                        this.customValues,
                        cv.stakeholder_custom_column_id,
                        cv.col_value
                    );
                });
            }
        } else {
            this.entity.stakeholder_category_id = this.category.id;
        }
    },
    methods: {
        async saveForm() {
            try {
                const method = this.editing ? "PUT" : "POST";
                // Build custom_values array from customValues object
                const custom_values = Object.keys(this.customValues).map(
                    columnId => ({
                        stakeholder_custom_column_id: parseInt(columnId),
                        col_value: this.customValues[columnId]
                    })
                );
                const payload = {
                    ...this.entity,
                    custom_values
                };
                await StakeholderService[method](payload);
                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
            }
        },
        async deleteEntity() {
            this.$swal({
                icon: "warning",
                text: this.$t("stakeholders.confirm_delete_stakeholder"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    try {
                        this.$notify({
                            message: this.$t("stakeholders.deleted"),
                            timeout: 5000,
                            icon: "far fa-check",
                            type: "success"
                        });
                        await StakeholderService.DELETE(this.entity.id);

                        this.$emit("close-reload");
                    } catch (e) {}
                }
            });
        }
    }
};
</script>

<template>
    <modal size="xl" :show="true" @close="$emit('close')" class="budget-modal">
        <template slot="header">
            <template v-if="editing">{{ $t("stakeholders.edit") }}</template>
            <template v-else>{{ $t("stakeholders.add") }}</template>
        </template>
        <h4 class="mb-5">
            {{ $t("stakeholders.category") }} {{ category.name }}
        </h4>

        <template slot="default">
            <FormulateForm :errors="errors" @submit="saveForm" v-model="entity">
                <div class="row">
                    <FormulateErrors />

                    <div
                        v-for="(col, key) in columns"
                        v-if="category[key]"
                        :key="key"
                        class="col-12"
                    >
                        <FormulateInput
                            v-if="col === 'custom_number'"
                            :name="col"
                            type="text"
                            :label="
                                $t(`stakeholders.hdr_custom_number_LABEL`, {
                                    LABEL: category.custom_number_col_name
                                })
                            "
                            :placeholder="$t(`stakeholders.hdr_${col}`)"
                            :validation-name="$t(`stakeholders.hdr_${col}`)"
                        />
                        <FormulateInput
                            v-else-if="col === 'custom_string'"
                            :name="col"
                            type="text"
                            :label="
                                $t('stakeholders.hdr_custom_string_LABEL', {
                                    LABEL: category.custom_string_col_name
                                })
                            "
                            :placeholder="$t(`stakeholders.hdr_${col}`)"
                            :validation-name="$t(`stakeholders.hdr_${col}`)"
                        />
                        <FormulateInput
                            v-else-if="col === 'note'"
                            :name="col"
                            type="textarea"
                            :label="$t(`stakeholders.hdr_${col}`)"
                            :placeholder="$t(`stakeholders.hdr_${col}`)"
                            :validation-name="$t(`stakeholders.hdr_${col}`)"
                        />
                        <FormulateInput
                            v-else
                            :name="col"
                            type="text"
                            :label="$t(`stakeholders.hdr_${col}`)"
                            :placeholder="$t(`stakeholders.hdr_${col}`)"
                            :validation-name="$t(`stakeholders.hdr_${col}`)"
                        />
                    </div>
                    <!-- Custom columns -->
                    <div
                        v-for="customCol in customColumns"
                        :key="'cc-' + customCol.id"
                        class="col-12"
                    >
                        <FormulateInput
                            v-model="customValues[customCol.id]"
                            type="text"
                            :label="customCol.name"
                            :placeholder="customCol.name"
                        />
                    </div>
                    <div class="col-12">
                        <div class="row mt-4">
                            <div class="col">
                                <base-button
                                    type="danger"
                                    :outline="true"
                                    @click="deleteEntity"
                                    v-if="editing"
                                    ><i class="far fa-trash"></i>
                                    {{ $t("delete") }}</base-button
                                >
                            </div>
                            <div class="col text-right">
                                <base-button
                                    type="secondary"
                                    :outline="true"
                                    @click="$emit('close')"
                                    >{{ $t("cancel") }}</base-button
                                >
                                <base-button
                                    type="primary"
                                    native-type="submit"
                                    >{{ $t("save") }}</base-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
